import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssinaturaResultado, AssinaturaStatus, CriarAssinatura } from 'app/models/assinatura.model';
import { RespostaPadrao } from 'app/models/resposta-padrao.model';
import { environment } from 'environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AssinaturaService {
  constructor(private httpClient: HttpClient) {}

  obterStatus(): Promise<AssinaturaStatus> {
    return firstValueFrom(
      this.httpClient.get<AssinaturaStatus>(`${environment.urlApi}/Assinatura/status`)
    );
  }

  assinar(dto: CriarAssinatura): Promise<AssinaturaResultado> {
    return firstValueFrom(
      this.httpClient.post<AssinaturaResultado>(`${environment.urlApi}/Assinatura/assinar`, dto)
    );
  }

  obterLinkPagamento(): Promise<AssinaturaResultado> {
    return firstValueFrom(
      this.httpClient.get<AssinaturaResultado>(`${environment.urlApi}/Assinatura/link-pagamento`)
    );
  }

  cancelar(): Promise<RespostaPadrao> {
    return firstValueFrom(
      this.httpClient.post<RespostaPadrao>(`${environment.urlApi}/Assinatura/cancelar`, {})
    );
  }
}
